/** Optional browser persistence must not prevent session cleanup or navigation. */
export function tryBrowserStorage<T>(operation: () => T): T | undefined {
  try {
    return operation();
  } catch (error) {
    console.warn('Browser storage is unavailable:', error);
  }
}
